/* Custom JavaScript for Bathshack */

document.addEventListener("DOMContentLoaded", () => {
  // Function to reformat price values
  function reformatPrices() {
    // Define a regular expression to match European-style formatted prices
    const priceRegex = /\b\d{1,3}(\.\d{3})*(,\d{2})\b/g;

    // Get all text nodes on the page
    const textNodes = [];
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );
    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    // Iterate through text nodes to find and replace price values
    textNodes.forEach((node) => {
      const originalText = node.nodeValue;
      if (priceRegex.test(originalText)) {
        const newText = originalText.replace(priceRegex, (match) => {
          // Remove any currency symbol (e.g., €) if present
          const cleanMatch = match.replace(/[^\d.,]/g, "");

          // Replace periods with nothing, commas with periods, and parse to number
          const europeanFormatted = cleanMatch
            .replace(/\./g, "")
            .replace(",", ".");
          const numberValue = parseFloat(europeanFormatted);

          // Format to British/Irish style
          return new Intl.NumberFormat("en-GB", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(numberValue);
        });
        node.nodeValue = newText;
      }
    });
  }

  // Run the function initially
  reformatPrices();

  // Watch for DOM changes and reapply the formatting
  const observer = new MutationObserver(() => reformatPrices());
  observer.observe(document.body, { childList: true, subtree: true });

  //accordaion toddle
  function accordaionToddle() {
    const toggleBtn = document.getElementById("toggleAccordion");
    const content = document.getElementById("accordionContent");
    if (toggleBtn && content) {
      toggleBtn.addEventListener("click", () => {
        content.classList.toggle("show");
        toggleBtn.classList.toggle("open");
      });
    }
  }

  accordaionToddle();
});

document.addEventListener("DOMContentLoaded", function () {
  const container = document.getElementById("recommended-addons");
  const wrapper = document.querySelector(".add-all-addons-wrapper");
  const addAllBtn = document.querySelector(".add-all-addons");
  if (!container || !addAllBtn || !wrapper) return;

  const productId = container.dataset.productId;
  const mainVariantId = parseInt(container.dataset.mainVariantId, 10);

  // Step 1: Fetch recommended products
  fetch(
    `${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=4&intent=complementary`
  )
    .then((response) => response.json())
    .then(({ products }) => {
      if (products.length > 0) {
        wrapper.style.display = "block";
        addAllBtn.disabled = false;

        const variantIds = products.map((p) => p.variants[0].id);
        addAllBtn.dataset.variants = JSON.stringify(variantIds);
      } else {
        wrapper.style.display = "none";
      }
    })
    .catch((err) => {
      console.error("Recommendation fetch error:", err);
      wrapper.style.display = "none";
    });

  /**
   * ✅ Block 1: Add ALL (Main Product + Recommended)
   */
  addAllBtn.addEventListener("click", function () {
    const variants = JSON.parse(this.dataset.variants || "[]");
    if (!variants.length && !mainVariantId) return;

    addAllBtn.textContent = "Adding...";
    addAllBtn.disabled = true;

    const items = [
      { id: mainVariantId, quantity: 1 },
      ...variants.map((id) => ({ id, quantity: 1 })),
    ];

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Add to cart failed");
        return res.json();
      })
      .then((responseJson) => {
        addAllBtn.textContent = "Added!";

        // ✅ Dispatch events
        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: { product: responseJson },
            bubbles: true,
          })
        );
        document.dispatchEvent(new Event("cart:updated"));

        // ✅ Refresh Drawer
        refreshCartDrawer();

        updateCartBubble();
      })
      .catch((err) => {
        console.error("Add all add-ons error:", err);
        addAllBtn.textContent = "Error! Try Again";
      })
      .finally(() => {
        setTimeout(() => {
          addAllBtn.textContent = "+ Add All Add-Ons";
          addAllBtn.disabled = false;
        }, 3000);
      });
  });

  /**
   * ✅ Block 2: Individual Add Buttons (Using Delegation)
   */
  document.addEventListener("click", function (e) {
    if (
      (e.target && e.target.classList.contains("add-this-addons")) ||
      (e.target && e.target.classList.contains("add-this-item-to-cart"))
    ) {
      const button = e.target;
      const variantId = parseInt(button.dataset.variants, 10);
      const buttonText = e.target.textContent;
      if (!variantId) return;

      button.textContent = "Adding...";
      button.disabled = true;

      const payload = {
        id: variantId,
        quantity: 1,
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
        .then((res) => {
          if (!res.ok) throw new Error("Add to cart failed");
          return res.json();
        })
        .then((responseJson) => {
          button.textContent = "Added!";

          // ✅ Dispatch events
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added", {
              detail: { product: responseJson },
              bubbles: true,
            })
          );
          document.dispatchEvent(new Event("cart:updated"));

          refreshCartDrawer();
          updateCartBubble();
        })
        .catch((err) => {
          console.error("Add-on add error:", err);
          button.textContent = "Error! Try Again";
        })
        .finally(() => {
          setTimeout(() => {
            button.textContent = buttonText;
            button.disabled = false;
          }, 3000);
        });
    }
  });

  /**
   * ✅ Shared Helper Functions
   */
  function refreshCartDrawer() {
    if (
      typeof Shopify !== "undefined" &&
      Shopify.theme &&
      Shopify.theme.ajaxCart &&
      Shopify.theme.ajaxCart.load
    ) {
      Shopify.theme.ajaxCart.load();
    } else if (
      window.CartDrawer &&
      typeof window.CartDrawer.refresh === "function"
    ) {
      window.CartDrawer.refresh();
    }
  }
});

function updateCartBubble() {
  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const cartBubble = document.getElementById("cart-bubble");
      if (cart.item_count > 0) {
        cartBubble.classList.add("cart-link__bubble--visible");
        cartBubble.textContent = cart.item_count;
      } else {
        cartBubble.classList.remove("cart-link__bubble--visible");
        cartBubble.textContent = "";
      }
    });
}

document.body.addEventListener("ajaxProduct:added", updateCartBubble);
document.addEventListener("cart:updated", updateCartBubble);

/* Preorder Custom JS start */

function bucketFromTs(ts) {
  const d = new Date(Number(ts) * 1000);
  const day = d.getDate();
  return day <= 10 ? 'early' : day <= 20 ? 'mid' : 'end';
}

function formatMonthYear(ts) {
  if (!ts) return null;
  const d = new Date(Number(ts) * 1000);
  return new Intl.DateTimeFormat(undefined, { month: 'short', year: 'numeric' }).format(d);
}

function bucketWord(bucket) {
  if (bucket === 'early') return theme.strings?.stockEstimatedEarly || 'early';
  if (bucket === 'mid')   return theme.strings?.stockEstimatedMid   || 'mid';
  if (bucket === 'end')   return theme.strings?.stockEstimatedEnd   || 'end';
  return '';
}

function buildPreorderMessage(variantId, productId) {
  const inv = window.inventories?.[productId]?.[variantId];
  if (!inv || !inv.preorder || !inv.preorder_due_ts) return theme.strings?.waitingForStockGeneric;

  const nowSec = Math.floor(Date.now() / 1000);
  if (inv.preorder_due_ts <= nowSec) return theme.strings?.waitingForStockGeneric;

  const monthYear = formatMonthYear(inv.preorder_due_ts);
  const bucket = bucketFromTs(inv.preorder_due_ts);
  const prefix = theme.strings?.stockEstimatedPrefix || 'Stock estimated';
  return `${prefix} ${bucketWord(bucket)} ${monthYear}`;
}
/* Preorder Custom JS end */


function applyLineStatus() {
  const isOpen = sessionStorage.getItem('line_status') === 'true';
  
  document.querySelectorAll('.line-logic-btn').forEach(link => {
    if (!isOpen) {
      link.classList.add('disabled'); // style in CSS
      link.addEventListener('click', preventClick, true);
    } else {
      link.classList.remove('disabled');
      link.removeEventListener('click', preventClick, true);
    }
  });
}

function preventClick(e) {
  e.preventDefault();
  e.stopPropagation();
  alert('Sorry, our line is currently closed.');
}

// Run once now
applyLineStatus();

// Run every 6 seconds after your status update
setInterval(applyLineStatus, 6000);

// Update preferences 
(function waitForPrefsContainer(){
  const SELECTOR = '.shopify-pc__prefs__options';

  function apply(container){
    container.querySelectorAll('input[type="checkbox"]').forEach(cb => {
      if (!cb.closest('#shopify-pc__prefs__essential')) {
        cb.checked = true;
        cb.defaultChecked = true;
        cb.setAttribute("checked", "true");
        cb.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });

    container.querySelectorAll('svg[data-icon-type]').forEach(svg => {
      if (svg.closest('#shopify-pc__prefs__essential')) return;
      const type = svg.getAttribute("data-icon-type");
      if (type === "unchecked") svg.style.display = "none";
      if (type === "checked") svg.style.display = "block";
    });
  }

  const observer = new MutationObserver(() => {
    const container = document.querySelector(SELECTOR);
    if (container) {
      apply(container);
      observer.disconnect();
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
    // 1) Remember the last non-search page as the "origin"
    try {
      if (!location.pathname.startsWith('/search')) {
        sessionStorage.setItem('searchOriginUrl', location.href);
      }
    } catch (e) {}

    // 2) Hijack close button click (capture phase to beat other listeners)
    document.addEventListener('click', function (e) {
      const closeBtn = e.target.closest('.btn--close-search');
      if (!closeBtn) return;

      // Prevent theme/Boost default behavior
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      let origin = null;
      try { origin = sessionStorage.getItem('searchOriginUrl'); } catch (e) {}

      // If we have a sane origin, go there
      if (origin && !origin.includes('/search')) {
        window.location.assign(origin);
        return;
      }

      // Fallbacks
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.assign('/');
      }
    }, true); // <-- capture phase
  })();

  (function () {
  function initShowroomBugModal() {
    const backdrop = document.getElementById('ShowroomBugModalBackdrop');
    const modal = document.getElementById('ShowroomBugModal');
    const closeBtn = document.getElementById('ShowroomBugClose');
    const formWrapper = document.getElementById('ShowroomBugFormWrapper');

    if (!backdrop || !modal || !closeBtn) return;

    function closeModal() {
      backdrop.classList.remove('is-active');
      backdrop.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('showroom-bug-modal-open');

      // Force release focus from Shopify shadow DOM / iframe
      if (document.activeElement) {
        document.activeElement.blur();
      }

      // Reset Shopify form render state after close
      const shopifyEmbed = formWrapper?.querySelector('shopify-forms-embed');

      if (shopifyEmbed) {
        shopifyEmbed.style.pointerEvents = 'none';

        setTimeout(() => {
          shopifyEmbed.style.pointerEvents = '';
        }, 150);
      }
    }

    function openModal() {
      backdrop.classList.add('is-active');
      backdrop.setAttribute('aria-hidden', 'false');
      document.body.classList.add('showroom-bug-modal-open');
    }

    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      closeModal();
    });

    backdrop.addEventListener('click', function (e) {
      if (e.target === backdrop) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && backdrop.classList.contains('is-active')) {
        closeModal();
      }
    });

    window.openShowroomBugModal = openModal;
    window.closeShowroomBugModal = closeModal;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShowroomBugModal);
  } else {
    initShowroomBugModal();
  }
})();